import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import {
    LoanOptionsRequest,
    LoanOptionsResponse,
    LoanTermContentParams,
    LoanTermState,
} from './loanTermTypes';

import { initialStateLoanTerm as initialState } from './loanTermDefaultValue';
import { ApiStatus } from '../../types';

const loanTermSlice = createSlice({
    name: 'loanTerm',
    initialState,
    reducers: {
        submitLoanTerm: (state) => state,
        getLoanTerms(state, action: PayloadAction<LoanOptionsRequest>) {
            state.loanOptionsRequest = action.payload;
            state.getLoanTermApiStatus = ApiStatus.Pending;
        },
        getLoanTermsFulfilled(state, action: PayloadAction<LoanOptionsResponse>) {
            state.getLoanTermApiStatus = ApiStatus.Fulfilled;
            
            const {
                content,
                ...restData
            } = action.payload;
            
            state.content = JSON.parse(content);
            state.loanOptions = restData;
        },
        getLoanTermsRejected(state) {
            state.getLoanTermApiStatus = ApiStatus.Rejected;
        },
        updateLoanTerm(state, action: PayloadAction<LoanOptionsRequest>) {
            state.updateLoanTermApiStatus = ApiStatus.Pending;
            state.loanOptionsRequest = action.payload;
        },
        updateLoanTermsFulfilled(state) {
            state.updateLoanTermApiStatus = ApiStatus.Fulfilled;
        },
        updateLoanTermsRejected(state) {
            state.updateLoanTermApiStatus = ApiStatus.Rejected;
        },
        updateLoanTermContentParams(state, action: PayloadAction<LoanTermContentParams>) {
            state.contentParams = {
                ...state.contentParams,
                ...action.payload,
            };
        },
        updateLoanTermRequest: (state, action: PayloadAction<LoanOptionsRequest>) => {
            state.loanOptionsRequest = action.payload;
        },
        updateSelectedLoanTerms(state, action: PayloadAction<number>) {
            state.loanOptions.loanTermYear = action.payload;
        },
        resetLoanTermStatus(state) {
            state.getLoanTermApiStatus = ApiStatus.Idle;
            state.updateLoanTermApiStatus = ApiStatus.Idle;
        },
    },
});

export const {
    getLoanTerms,
    getLoanTermsFulfilled,
    getLoanTermsRejected,
    updateLoanTerm,
    updateLoanTermsFulfilled,
    updateLoanTermsRejected,
    updateLoanTermContentParams,
    updateLoanTermRequest,
    updateSelectedLoanTerms,
    resetLoanTermStatus,
    submitLoanTerm,
} = loanTermSlice.actions;

export const loanTermReducer: Reducer<LoanTermState, AnyAction> = loanTermSlice.reducer;
